import { render, staticRenderFns } from "./SalesForecastTotalList.vue?vue&type=template&id=68a82682&"
import script from "./SalesForecastTotalList.vue?vue&type=script&lang=js&"
export * from "./SalesForecastTotalList.vue?vue&type=script&lang=js&"
import style0 from "./SalesForecastTotalList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports